import CloseIcon from '@mui/icons-material/Close'
import { AppBar, Box, Container, IconButton, Stack, Toolbar, Typography } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import Slide from '@mui/material/Slide'
import { DataGrid } from 'Components/LifeDataGrid'
import CustomButton from 'Components/CustomButton/CustomButton'
import * as React from 'react'
import { useState } from 'react'
import { makeGetRequest, makePostRequest } from 'utils/api'
import CreateCategory from './CreateCategoriesModal'
import EditContactCategory from './SelectAndModifyCategories'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)
// import EditContactCategory from 'SelectAndModifyCategories'

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})
const ITEM_HEIGHT = 50
const ITEM_PADDING_TOP = 8

export default function ManageCategory() {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [open, setOpen] = React.useState(false)
  const [openEditList, setOpenEditList] = React.useState(false)
  const [editId, setEditId] = React.useState(false)
  const [rows, setRows] = useState(100)
  const [page, setPage] = useState(0)
  const [categories, setCategorys] = useState([])
  const [selectedRows, setSelectedRows] = useState([])

  const columns = [
    {
      field: 'Categorie',
      headerName: 'Categorie',
      width: 400,
      editable: false,
    },
    {
      field: 'SousCategorie',
      headerName: 'SousCategorie',
      width: 400,
      editable: false,
    },
    {
      field: 'id',
      headerName: 'Contact',

      width: 250,
      editable: false,
      renderCell: (params) => {
        return (
          <Box
            component="span"
            onClick={() => {
              setEditId(params.row.id)
              setOpenEditList(true)
            }}
            sx={{ color: '#3481b9', cursor: 'pointer' }}
          >
            List of contacts
          </Box>
        )
      },
    },
  ]
  const fetchCategorys = async (pagination = '') => {
    let url = `/api/Social/get-categories-option/`
    if (pagination !== '') {
      //general=true&
      url += pagination
    }
    setTimeout(2)
    const response = await makeGetRequest(url, {}, true)
    if (response.status === 200) {
      setCategorys(response.data)
    }
  }

  const deleteBulkOperations = async () => {
    if (selectedRows.length === 0) {
      alert('Sélectionner une contacts ')
    } else {
      const response = await makePostRequest(
        '/api/Social/delete-category/',
        { selected: selectedRows },
        {},
        true,
      )
      if (response.status === 200) {
        console.log('Deleted Successfully')
      }
    }
    fetchCategorys()
  }
  const handleRowsChange = (newPageSize) => {
    setRows(newPageSize)
    let url = `&limit=${newPageSize}&offset=${page}`
    fetchCategorys(url)
  }
  const handlePageChange = (newPage) => {
    setPage(newPage * rows)
    let url = `&limit=${rows}&offset=${newPage * rows}`
    fetchCategorys(url)
  }

  const handleClickOpen = async () => {
    setOpen(true)
    fetchCategorys()
  }

  const handleClose = () => {
    setOpen(false)
  }

  return (
    <>
      {openEditList && <EditContactCategory id={editId} setOpen={setOpenEditList} />}
      {/* LAP-733 (GE022) */}
      <CustomButton onClick={handleClickOpen}>{t('contacts.btnRelation')}</CustomButton>

      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        PaperProps={{
          style: {
            backgroundColor: 'rgba(0, 27, 66, 0.9)',
            color: '#fff',
          },
        }}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: 'relative' }}>
          <Toolbar style={{ color: '#fff', backgroundColor: 'black' }}>
            <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Gestion des categories de contacts
            </Typography>
          </Toolbar>
        </AppBar>
        <Container
          maxWidth="lg"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            flexWrap: 'wrap',
            padding: '20px',
          }}
        >
          <div>
            <Typography variant="h5" sx={{ fontWeight: 600 }}>
              Gestion des categories de contacts
            </Typography>
          </div>
          <div>
            <CreateCategory fetchCategorys={fetchCategorys} />
            <CustomButton onClick={deleteBulkOperations}>Supprimer</CustomButton>
          </div>
          <div
            style={{
              height: 750,
              width: '100% ',
              color: 'black',
              background: 'white',
              borderRadius: '5px',
            }}
          >
            <DataGrid
              columns={columns}
              rows={categories}
              // columns={columns}
              // rows={categories}
              // rowCount={categories !== undefined ? categories.length : 0}
              // pageSize={rows}
              // onPageSizeChange={handleRowsChange}
              // onPageChange={handlePageChange}
              // rowsPerPageOptions={[10, 20, 40, 80, 100]}
              // pagination
              onSelectionModelChange={(itm) => setSelectedRows([...itm])}
              // paginationMode="server"
              components={{
                NoRowsOverlay: () => (
                  <Stack height="100%" alignItems="center" justifyContent="center">
                    Aucune donnée trouvée
                  </Stack>
                ),
                NoResultsOverlay: () => (
                  <Stack height="100%" alignItems="center" justifyContent="center">
                    Aucune donnée trouvée
                  </Stack>
                ),
              }}
              checkboxSelection
            />
          </div>
        </Container>
      </Dialog>
    </>
  )
}
